import { FC, useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { useGetPublicSystemSettingsQuery } from 'services/publicTeamHeroApi.service';
import { setTracesSampleRate } from 'config/sentry.config';

const SentryProvider: FC = () => {
  const { data } = useGetPublicSystemSettingsQuery();

  useEffect(() => {
    if (data) {
      Sentry.setTag('system_host', data.settings.system_host || 'unset');
      setTracesSampleRate(data.settings.sentry_traces_sample_rate);
    }
  }, [data]);

  return null;
};

export default SentryProvider;
